// extracted by mini-css-extract-plugin
module.exports = {"wt-radio-slot":"wt-radio-slot-0d070888c5147e77efa9010b29e98947"};